import { Component, OnInit, inject } from '@angular/core';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable, Subject, takeUntil } from 'rxjs';
import { BlogTags } from '../../_shared/_enums/blog-tags';
import { SEO, IShopifyProduct } from '@app/_shared/_models';
import { BlogService } from '../../_shared/_services/blog.service';
import { ProductService } from '../../_shared/_services/product.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { IBlogPost } from '../_prismic/blog-post';
import { ImageComponent } from '../../_shared/_components/image/image.component';
import { ProductCardComponent } from '../../_shared/_components/product-card/product-card.component';
import { BlockQuoteComponent } from '../../_shared/_components/block-quote/block-quote.component';
import { AsyncPipe, UpperCasePipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-freshwater-salt-system-cartridges-now-available',
    templateUrl: './freshwater-salt-system-cartridges-now-available.component.html',
    styleUrls: ['./freshwater-salt-system-cartridges-now-available.component.scss'],
    imports: [NgxSpinnerComponent, ImageComponent, ProductCardComponent, BlockQuoteComponent, RouterLink, AsyncPipe, UpperCasePipe, DatePipe]
})
export class FreshwaterSaltSystemCartridgesNowAvailableComponent implements OnInit {
  private readonly blogService = inject(BlogService);
  private readonly ngxSpinnerService = inject(NgxSpinnerService);
  private readonly productService = inject(ProductService);
  private readonly seoService = inject(SeoService);

  public seo: SEO = {
    image: 'https://mypoolhut.com/assets/images/WomenInPoolWithLogoReverse.jpg',
    metaDescription: `My Pool Hut is now selling Freshwater Salt System Cartridges for the first time. We are one of the very few sellers of this product online! Buy one today!`,
    metaTitle: `Freshwater Salt System Cartridges Now Available Online!`
  };
  public spinner$: Observable<NgxSpinner>;
  public product$: Observable<IShopifyProduct | undefined>;
  public blogPost!: IBlogPost;
  private readonly blogTags = BlogTags;
  private readonly unsubscribe: Subject<undefined> = new Subject<undefined>();

  constructor() {
    const ngxSpinnerService = this.ngxSpinnerService;

    this.spinner$ = ngxSpinnerService.spinnerObservable;
    this.product$ = this.productService.product$;
  }

  public async ngOnInit(): Promise<void> {
    this.seoService.setMetaData(this.seo);
    this.seoService.createCanonicalUrl('https://mypoolhut.com/blog/freshwater-salt-system-cartridges-now-available');

    await this.ngxSpinnerService.show();
    this.blogService.blogs$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async (blogs: Array<IBlogPost>) => {
        const index = blogs.findIndex(b => b.tag === this.blogTags.FRESHWATER_SALT_SYSTEM_CARTRIDGES);
        if (index > -1) {
          this.blogPost = blogs[index];
          await this.ngxSpinnerService.hide();
        } else {
          await this.blogService.loadBlogs();
        }
      });

    this.productService.loadProductByHandle('freshwater-salt-system-cartridge');
  }

  public ngOnDestroy(): void {
    this.seoService.removeCanonicalUrl();
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

}
